import Select, { components } from "react-select";
import AsyncSelect from "react-select/async";
import { Input } from "reactstrap";
import React, { Component } from "react";
import PropTypes from "prop-types";

class MultipleSelect extends Component {
  Option = props => {
    return (
      <div>
        <components.Option {...props}>
          <Input
            type="checkbox"
            checked={props.isSelected}
            onChange={() => null}
          />{" "}
          <label>{props.label}</label>
        </components.Option>
      </div>
    );
  };

  ValueContainer = props => {
    const currentValues = props.getValue();
    const selectedValue =
      currentValues.length && currentValues.length === 1
        ? currentValues[0].label
        : `${currentValues.length} selected`;
    const input = props.children[props.children.length - 1];
    const toBeRendered = currentValues.length
      ? [selectedValue, input]
      : props.children;

    return (
      <components.ValueContainer {...props}>
        {toBeRendered}
      </components.ValueContainer>
    );
  };

  render() {
    const isAsync = this.props.options instanceof Function;
    const NecessarySelect = isAsync ? AsyncSelect : Select;

    return (
      <NecessarySelect
        cacheOptions={isAsync}
        closeMenuOnSelect={false}
        options={!isAsync && this.props.options}
        loadOptions={isAsync && this.props.options}
        placeholder={this.props.placeholder}
        components={{
          IndicatorSeparator: null,
          Option: this.Option,
          ValueContainer: this.ValueContainer,
        }}
        styles={{
          option: base => ({
            ...base,
            wordBreak: "break-all",
            paddingLeft: "32px",
          }),
          valueContainer: base => ({
            ...base,
            display: "flex",
            flexWrap: "nowrap",
          }),
          container: base => ({
            ...base,
            height: this.props.fullHeight ? "100%" : "36px",
          }),
          clearIndicator: base => ({
            ...base,
            padding: "7px",
          }),
          dropdownIndicator: base => ({
            ...base,
            padding: "7px",
          }),
          control: base => ({
            ...base,
            minHeight: this.props.fullHeight ? "100%" : "34px",
          }),
          placeholder: base => ({
            ...base,
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
            overflow: "hidden",
          }),
        }}
        hideSelectedOptions={false}
        isMulti
        onChange={this.props.onChange}
      />
    );
  }
}

MultipleSelect.defaultProps = {
  options: [],
  placeholder: "Select",
  onChange: () => {},
  fullHeight: false,
};

MultipleSelect.propTypes = {
  options: PropTypes.oneOfType([PropTypes.array, PropTypes.func]),
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
  fullHeight: PropTypes.bool,
};

export default MultipleSelect;
